function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import autobind from 'react-autobind';
import blankPNG from '../../common/blank-png';
import ConfigHelper from './formUtils';
import constants from '../../../lib/shared/constants';
import errorSVG from '../../common/error-svg';
import messages from '../../../nls/setup/deploy/deploy.properties';
import commonMsgs from '../../../nls/common.properties';
import IntegrationDetails from './integration-details.jsx';
import Markdown from '../../common/markdown.jsx';
import DeployButtons from '../deploy-buttons.jsx';
import Notification from '../../common/notification.jsx';
import OtherToolsSVG from '../../../graphics/more-tools.svg';
import React from 'react';
import Phase from '../../common/model/phase';
import PropTypes from 'prop-types';
import WizardToolsPanel from '../wizard-tools-panel.jsx';
import { Accordion, Checkbox, FormLabel, InlineNotification, ProgressIndicator, ProgressStep, SkeletonText, Tab, TabList, TabPanel, TabPanels, Tabs, Tag, Toggle, Toggletip, ToggletipButton, ToggletipContent, Tooltip } from '@carbon/react';
import { Information } from '@carbon/react/icons';
import '../../../scss/setup/deploy/_service-tabs.scss';
var ServiceTabs = /*#__PURE__*/function (_React$Component) {
  function ServiceTabs(props) {
    var _this;
    _classCallCheck(this, ServiceTabs);
    _this = _callSuper(this, ServiceTabs, [props]);
    autobind(_this);
    _this.configHelper = new ConfigHelper(_this);
    _this.hideValidate = false;
    _this.state = {
      hideValidate: _this.hasValidator(_this.props.capabilities),
      isWizardInvalid: false,
      wizardPageMode: {}
    };
    return _this;
  }
  _inherits(ServiceTabs, _React$Component);
  return _createClass(ServiceTabs, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.listenForAuth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.wizardMode) {
        // Check wizard validity and update if status has changed
        var isInvalid = this.checkWizardInvalid();
        if (isInvalid && !this.state.isWizardInvalid) {
          this.setState({
            isWizardInvalid: true
          });
        } else if (!isInvalid && this.state.isWizardInvalid) {
          this.setState({
            isWizardInvalid: false
          });
        }
      }
      if (prevProps.integrationsAuthDone !== this.props.integrationsAuthDone && !this.props.integrationsAuthDone) {
        // When switching sourceProvider or pipelineType, the integrations auth prop is reset to false
        // We need to call listenForAuth again so that the auth prop is updated to true after auth is complete
        this.listenForAuth();
      }
    }
  }, {
    key: "hasValidator",
    value: function hasValidator(capabilities) {
      for (var index = 0; index < capabilities.length; index++) {
        if (capabilities[index].schema && capabilities[index].schema.form) {
          for (var i = 0; i < capabilities[index].schema.form.length; i++) {
            if (capabilities[index].schema.form[i].type === "validator") {
              return true;
            }
          }
        }
      }
      return false;
    }
  }, {
    key: "hidePipelineRepos",
    value: function hidePipelineRepos(mainTools) {
      var toolList = mainTools;
      if (mainTools && mainTools.length > 0) {
        toolList = mainTools.filter(function (toolCapabilities) {
          var pipelineAsCode = false;
          if (toolCapabilities.parameters) {
            var kind = (toolCapabilities.parameters || {}).kind;
            var repoKind = 'pipeline';
            pipelineAsCode = kind && kind.indexOf(repoKind) !== -1;
          }
          return !pipelineAsCode;
        });
      }
      return toolList;
    }
  }, {
    key: "hideMainPipelineRepos",
    value: function hideMainPipelineRepos(mainTools) {
      var _this2 = this;
      var toolList = mainTools;
      if (mainTools && mainTools.length > 0) {
        toolList = mainTools.filter(function (toolType) {
          var toolCapabilities = _this2.props.capabilities.getByType(toolType);
          var pipelineAsCode = false;
          for (var index = 0; index < toolCapabilities.length; index++) {
            var capability = toolCapabilities[index];
            if (capability.parameters) {
              var kind = (capability.parameters || {}).kind;
              if (kind === undefined) {
                pipelineAsCode = false;
                break;
              }
              var repoKind = 'pipeline';
              pipelineAsCode = kind && kind.indexOf(repoKind) !== -1;
            }
          }
          return !pipelineAsCode;
        });
      }
      return toolList;
    }
  }, {
    key: "findPipelineRepos",
    value: function findPipelineRepos(mainTools) {
      var toolList = mainTools;
      if (mainTools && mainTools.length > 0) {
        toolList = mainTools.filter(function (toolType) {
          var pipelineAsCode = false;
          if (toolType.parameters) {
            var kind = (toolType.parameters || {}).kind;
            var repoKind = 'pipeline';
            pipelineAsCode = kind && kind.indexOf(repoKind) !== -1;
            return pipelineAsCode;
          }
          return !pipelineAsCode;
        });
      }
      return toolList;
    }
  }, {
    key: "listenForAuth",
    value: function listenForAuth() {
      var _this3 = this;
      if (!this.hideValidate) {
        this.props.setAuthDone(true);
      }
      var listener;
      var tracker = this.props.validatorTracker;
      new Promise(function (resolve) {
        listener = resolve;
        tracker.on("allSettled", listener);
        tracker.on("validatorEvicted", listener);
      }).finally(function () {
        tracker.removeListener("allSettled", listener);
        tracker.removeListener("validatorEvicted", listener);
        _this3.setState({
          hideValidate: false
        });
        _this3.props.setAuthDone(true);
      });
    }
  }, {
    key: "getDisplayName",
    value: function getDisplayName(tool, toolCapabilities, toolMetadata, wizardStep) {
      var displayName = wizardStep && wizardStep.getLabel() || toolCapabilities && toolCapabilities.length > 0 && toolCapabilities[0].displayName || toolMetadata && (toolMetadata.displayName || toolMetadata.title) || tool;
      return displayName;
    }
  }, {
    key: "getToolImageUrl",
    value: function getToolImageUrl(toolCapabilities, toolMetadata, wizardStep) {
      // For wizard we pull the image from the wizardStep model. blankPNG not used by wizard
      // For classic we pull image from tool capability or metadata, if none found use blankPNG
      var toolImageURL = wizardStep && wizardStep.getImageUrl() || toolCapabilities && toolCapabilities.length > 0 && toolCapabilities[0].imageUrl || toolCapabilities && toolCapabilities.length > 0 && toolCapabilities[0].metadata && toolCapabilities[0].metadata.imageUrl || toolMetadata && toolMetadata.imageUrl || !wizardStep && blankPNG;
      return toolImageURL;
    }
  }, {
    key: "checkWizardInvalid",
    value: function checkWizardInvalid() {
      var _this4 = this;
      var wizard = this.props.capabilities.getWizard();
      var wizardSteps = wizard.getSteps({
        visibleOnly: true
      }) || [];
      var isConfigInvalid = !!wizardSteps.find(function (step) {
        return _this4.getWizardConfigRecommended(step);
      });
      var integrationsAuthDone = this.props.integrationsAuthDone;
      // In case of empty toolchain
      var capabilityCount = this.props.capabilities && this.props.capabilities.types().length;
      if (capabilityCount === 0) {
        integrationsAuthDone = true;
      }
      var areUnresolvedCapabilities = false;
      if (this.props.unresolved && this.props.unresolved.length > 0) {
        areUnresolvedCapabilities = true;
      }
      var isWizardInvalid = !this.props.isWizardWelcomeValid || wizard.showGitAccept() && !this.props.wizardGitAccept || !integrationsAuthDone || areUnresolvedCapabilities || this.props.capabilities && this.props.capabilities.types() && this.props.capabilities.types().length > 0 && isConfigInvalid;
      return isWizardInvalid;
    }
  }, {
    key: "renderFSCloudTag",
    value: function renderFSCloudTag(_ref) {
      var _toolCapabilities$;
      var tool = _ref.tool,
        wizardStep = _ref.wizardStep;
      if (!this.props.enableFSCloudDialog) {
        return;
      }
      var toolCapabilities;
      if (wizardStep) {
        var _wizardStep$getRender;
        toolCapabilities = (_wizardStep$getRender = wizardStep.getRenderData()) === null || _wizardStep$getRender === void 0 ? void 0 : _wizardStep$getRender.toolCapabilities;
      } else {
        var _this$props$capabilit;
        toolCapabilities = (_this$props$capabilit = this.props.capabilities) === null || _this$props$capabilit === void 0 ? void 0 : _this$props$capabilit.getByType(tool);
      }

      // Check if the curent step/tool is FSCloud Validated
      var fsCloudTag;
      if ((_toolCapabilities$ = toolCapabilities[0]) !== null && _toolCapabilities$ !== void 0 && (_toolCapabilities$ = _toolCapabilities$.service) !== null && _toolCapabilities$ !== void 0 && _toolCapabilities$.tags) {
        var tags = toolCapabilities[0].service.tags;
        if (tags.includes(constants.fsCloudTag)) {
          var fscloudTagId = "fscloud_tag_".concat(toolCapabilities[0].service_id || toolCapabilities[0].label) + (wizardStep ? "_".concat(wizardStep.getName()) : '');
          fsCloudTag = /*#__PURE__*/React.createElement(Tag, {
            id: fscloudTagId,
            type: "cyan"
          }, commonMsgs.get("tag.fscloud"));
        }
      } else if (wizardStep) {
        var _wizardStep$data;
        // Search through wizard conditions for FSCloud service being created
        var conditions = wizardStep._getConditions();
        var foundService;
        if (conditions !== null && conditions !== void 0 && conditions.length && (_wizardStep$data = wizardStep.data) !== null && _wizardStep$data !== void 0 && _wizardStep$data.name) {
          var _iterator = _createForOfIteratorHelper(conditions),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var condition = _step.value;
              var svcInCondition = wizardStep.findServiceInCondition(condition, wizardStep.data.name);
              if (svcInCondition) {
                foundService = svcInCondition;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          ;
          if (foundService) {
            var _capabilities$catalog;
            var capabilities = this.props.capabilities;
            var serviceTags = capabilities === null || capabilities === void 0 || (_capabilities$catalog = capabilities.catalog[foundService]) === null || _capabilities$catalog === void 0 ? void 0 : _capabilities$catalog.tags;
            if (serviceTags !== null && serviceTags !== void 0 && serviceTags.includes(constants.fsCloudTag)) {
              var _fscloudTagId = "fscloud_tag_".concat(foundService) + "_".concat(wizardStep.getName());
              fsCloudTag = /*#__PURE__*/React.createElement(Tag, {
                id: _fscloudTagId,
                type: "cyan"
              }, commonMsgs.get("tag.fscloud"));
            }
          }
        }
      }
      return fsCloudTag;
    }
  }, {
    key: "renderIntegrationDetails",
    value: function renderIntegrationDetails(tool, index, capability) {
      var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        accordionProps = _ref2.accordionProps;
      // Determine if there are required fields
      var configRecommended = this.props.configRecommended[tool];
      if (configRecommended && configRecommended.invalidProps.length === 0 && tool === "pipeline") {
        configRecommended = undefined;
      }
      return /*#__PURE__*/React.createElement(IntegrationDetails, _extends({}, this.props, {
        key: index,
        capability: capability,
        invalidFields: this.configHelper.arrayToSet(configRecommended ? configRecommended.invalidProps : configRecommended),
        validationMessages: configRecommended ? configRecommended.validationMessages : configRecommended,
        hideClass: this.state.hideValidate,
        lightBackground: true,
        accordionProps: accordionProps,
        mode: "setup"
      }));
    }
  }, {
    key: "renderWizardIntegrationDetails",
    value: function renderWizardIntegrationDetails(_ref3) {
      var _this5 = this;
      var capability = _ref3.capability,
        currentStepIndex = _ref3.currentStepIndex,
        invalidStepNames = _ref3.invalidStepNames,
        wizard = _ref3.wizard,
        wizardStep = _ref3.wizardStep;
      // Only show validation if all previous steps have been completed
      var welcomeOffset = wizard.getWelcomeOffset();
      var index = currentStepIndex - welcomeOffset; // Remove offset for welcome step

      // Determine if there are required fields
      var configRecommended = this.props.configRecommended[capability.label];
      if (configRecommended && configRecommended.invalidProps.length === 0 && capability.capabilityId === "pipeline") {
        configRecommended = undefined;
      }

      // Determine if there is an invalid secrets integration
      var secretsStepIndex = wizard.getSecretsStepIndex() + welcomeOffset; // Add offset to index to account for welcome step(s)
      var stepAfterSecretsStep = wizard.getStepByIndex(secretsStepIndex + 1);
      var hasInvalidSecretIntegration = stepAfterSecretsStep.indentLevel() > 0 && invalidStepNames.includes(stepAfterSecretsStep === null || stepAfterSecretsStep === void 0 ? void 0 : stepAfterSecretsStep.getName());
      return /*#__PURE__*/React.createElement(IntegrationDetails, _extends({}, this.props, {
        capability: capability,
        hasSecretsStep: wizard.hasSecretsStep(),
        hasInvalidSecretsIntegration: hasInvalidSecretIntegration,
        hideClass: this.state.hideValidate,
        invalidFields: this.configHelper.arrayToSet(configRecommended ? configRecommended.invalidProps : configRecommended),
        key: index,
        lightBackground: true,
        mode: "setup",
        openSecretsStep: function openSecretsStep() {
          if (hasInvalidSecretIntegration) {
            // A secret integration has been added, but it is invalid so jump to that step
            _this5.props.handleTabClick(secretsStepIndex + welcomeOffset);
          } else if (secretsStepIndex) {
            // No secret integrations have been added, jump to the vault step
            _this5.props.handleTabClick(secretsStepIndex);
          }
        },
        validationMessages: configRecommended ? configRecommended.validationMessages : configRecommended,
        wizardStep: wizardStep
      }));
    }
  }, {
    key: "renderRepoCapabilitiesList",
    value: function renderRepoCapabilitiesList(tool, repoCapabilities, showAuthLoadingState) {
      var _this6 = this;
      // Render list of tekton definition repos in Accordions
      var repoCapabilitiesList;
      if (showAuthLoadingState) {
        // TODO should use AccordionSkeleton here
        repoCapabilitiesList = /*#__PURE__*/React.createElement(SkeletonText, {
          paragraph: true,
          lineCount: 2,
          width: "45%"
        });
      } else {
        var tooltipTextSuffix = repoCapabilities && repoCapabilities.length > 1 ? messages.get('tekton.definitions.info.multiple.repos') : messages.get('tekton.definitions.info.single.repo');
        var tooltipText = "".concat(messages.get('tekton.definitions.info.intro'), " ").concat(tooltipTextSuffix);
        repoCapabilitiesList = /*#__PURE__*/React.createElement("div", {
          id: "tekton-defns-wrapper",
          className: "otc-accordion-wrapper"
        }, /*#__PURE__*/React.createElement("h4", {
          className: "otc-accordion-header"
        }, messages.get("tekton.definitions.heading"), /*#__PURE__*/React.createElement(Tooltip, {
          label: tooltipText,
          enterDelayMs: 0,
          leaveDelayMs: 0,
          align: "right"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "sb-tooltip-trigger"
        }, /*#__PURE__*/React.createElement(Information, null)))), /*#__PURE__*/React.createElement(Accordion, {
          id: "accordion",
          align: "end"
        }, repoCapabilities.map(function (capability, i) {
          var titleText = capability && capability.label;
          var accordionProps = {
            id: "otc-accordion-item-".concat(i),
            titleText: titleText
          };
          return _this6.renderIntegrationDetails(tool, i, capability, {
            accordionProps: accordionProps
          });
        })));
      }
      return repoCapabilitiesList;
    }
  }, {
    key: "renderTabContents",
    value: function renderTabContents(tool) {
      var _this7 = this;
      var toolMetadata = this.props.capabilities.getMetadata(tool);
      var toolCapabilities = this.props.capabilities.getByType(tool);

      //look for tekton repos
      var repoCapabilities = [];
      if (tool === "pipeline") {
        // look in repository types for pipeline kind
        constants.gitSourceProviders.forEach(function (srcProvider) {
          var providerRepos = _this7.findPipelineRepos(_this7.props.capabilities.getByType(srcProvider));
          repoCapabilities = [].concat(_toConsumableArray(repoCapabilities), _toConsumableArray(providerRepos));
        });
      }
      if (tool !== "pipeline") {
        toolCapabilities = this.hidePipelineRepos(toolCapabilities);
      }
      var displayName = this.getDisplayName(tool, toolCapabilities, toolMetadata);
      var toolImageURL = this.getToolImageUrl(toolCapabilities, toolMetadata);
      var showErrorState = false;
      if (this.props.unresolved.indexOf(tool) !== -1) {
        displayName = messages.get("error.unknownTool", [tool]);
        toolImageURL = errorSVG;
        showErrorState = true;
      }

      // If the auth flow has not completed for this type, might need to hide UI
      var showAuthLoadingState = false;
      if (!this.props.validatorTracker.authDone[tool]) {
        showAuthLoadingState = this.hasValidator(toolCapabilities) && this.state.hideValidate;
      }
      var renderTektonRepos = tool === "pipeline" && repoCapabilities && repoCapabilities.length > 0;
      return /*#__PURE__*/React.createElement("section", {
        ref: this[tool],
        key: tool,
        "data-service": tool
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-header"
      }, /*#__PURE__*/React.createElement("img", {
        className: "tab-content-image",
        src: toolImageURL,
        alt: ""
      }), displayName, this.renderFSCloudTag({
        tool: tool
      })), showErrorState && /*#__PURE__*/React.createElement("div", {
        className: "form-div markdown long-desc-div"
      }, /*#__PURE__*/React.createElement("p", null, messages.get("error.missingServiceInRegion", [tool]))), showAuthLoadingState ? /*#__PURE__*/React.createElement(SkeletonText, {
        paragraph: true,
        lineCount: 2,
        width: "45%"
      }) : toolCapabilities.map(function (capability, i) {
        return _this7.renderIntegrationDetails(tool, i, capability);
      }), renderTektonRepos && this.renderRepoCapabilitiesList(tool, repoCapabilities, showAuthLoadingState))));
    }
  }, {
    key: "renderWizardTabContents",
    value: function renderWizardTabContents() {
      var _this8 = this;
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        currentStepIndex = _ref4.currentStepIndex,
        _ref4$invalidStepName = _ref4.invalidStepNames,
        invalidStepNames = _ref4$invalidStepName === void 0 ? [] : _ref4$invalidStepName,
        isLastStep = _ref4.isLastStep,
        isWelcomeInvalid = _ref4.isWelcomeInvalid,
        showImage = _ref4.showImage,
        showTabContentHeader = _ref4.showTabContentHeader,
        wizard = _ref4.wizard,
        wizardStep = _ref4.wizardStep;
      // Get the render data from the wizardStep
      var _wizardStep$getRender2 = wizardStep.getRenderData(),
        tool = _wizardStep$getRender2.tool,
        toolMetadata = _wizardStep$getRender2.toolMetadata,
        toolCapabilities = _wizardStep$getRender2.toolCapabilities;
      var displayName = this.getDisplayName(tool, toolCapabilities, toolMetadata, wizardStep);
      var stepName = wizardStep.getName();
      var stepHeader = wizardStep && wizardStep.getTitle() || displayName;
      var toolImageURL = this.getToolImageUrl(toolCapabilities, toolMetadata, wizardStep);
      var errorState = null;
      if (this.props.unresolved.indexOf(tool) !== -1) {
        displayName = messages.get("error.unknownTool", [tool]);
        toolImageURL = errorSVG;
        errorState = /*#__PURE__*/React.createElement("div", {
          className: "form-div markdown long-desc-div"
        }, /*#__PURE__*/React.createElement("p", null, messages.get("error.missingServiceInRegion", [tool])));
      }
      if (isLastStep && this.state.isWizardInvalid) {
        // If showing create button then we are on the last step, e.g. Summary step
        // But when state is invalid, override summary content to render error notification instead
        if (isWelcomeInvalid) {
          // If welcome step is invalid, add its label to the list of invalid steps
          if (wizard.isV2() && !invalidStepNames.includes("toolchain")) {
            invalidStepNames.unshift("toolchain");
          } else if (!wizard.isV2() && !invalidStepNames.includes("welcome")) {
            invalidStepNames.unshift("welcome");
          }
        }
        var stepList = "";
        if (invalidStepNames.length) {
          invalidStepNames.forEach(function (stepName) {
            var step = wizard.getStepByName(stepName);
            if (step) {
              var stepLabel = step.getLabel();
              stepList = "".concat(stepList, "\n - ").concat(stepLabel);
            } else if (stepName === "welcome") {
              stepList = "".concat(stepList, "\n - ").concat(messages.get("label.welcome"));
            } else if (stepName === "toolchain") {
              stepList = "".concat(stepList, "\n - ").concat(messages.get("wizard.label.toolchain.step"));
            }
          });
        }
        // Note this subtitleText does not contain link, so no errors on using <InlineNotification
        var subtitleText = "".concat(messages.get("wizard.summary.invalid.subtitle")).concat(stepList);
        var subtitle = /*#__PURE__*/React.createElement(Markdown, {
          className: "summary-error",
          content: subtitleText
        });
        errorState = /*#__PURE__*/React.createElement(InlineNotification, {
          kind: "error",
          hideCloseButton: true,
          lowContrast: true,
          title: messages.get("wizard.summary.invalid.title")
        }, subtitle);
      }

      // If the auth flow has not completed for this type, might need to hide UI
      var showAuthLoadingState = false;
      if (!this.props.validatorTracker.authDone[tool]) {
        showAuthLoadingState = this.hasValidator(toolCapabilities) && this.state.hideValidate;
      }

      // Look for tekton repos. This is purely to show the tekton related repos on the deploy step
      var repoCapabilities = [];
      if (this.props.showTektonPipeline && tool === "pipeline") {
        // Look in repository types for pipeline kind
        constants.gitSourceProviders.forEach(function (srcProvider) {
          var providerRepos = _this8.findPipelineRepos(_this8.props.capabilities.getByType(srcProvider));
          repoCapabilities = [].concat(_toConsumableArray(repoCapabilities), _toConsumableArray(providerRepos));
        });
      }
      var renderTektonRepos = this.props.showTektonPipeline && tool === "pipeline" && repoCapabilities && repoCapabilities.length > 0;
      var isAdvancedMode = wizardStep.hasAdvancedForm() && this.state.wizardPageMode[wizardStep.getName()] === "advanced";
      return /*#__PURE__*/React.createElement("section", {
        ref: this[tool],
        key: tool,
        "data-service": tool,
        "data-step": wizardStep.getName()
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section"
      }, showTabContentHeader && /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-header"
      }, /*#__PURE__*/React.createElement("h3", null, showImage && toolImageURL && /*#__PURE__*/React.createElement("img", {
        className: "tab-content-image",
        src: toolImageURL,
        alt: ""
      }), stepHeader, this.renderFSCloudTag({
        wizardStep: wizardStep
      }))), errorState, !errorState && wizardStep.hasAdvancedForm() && /*#__PURE__*/React.createElement("div", {
        className: "advanced-options-container"
      }, /*#__PURE__*/React.createElement(FormLabel, {
        className: "advanced-options-label"
      }, /*#__PURE__*/React.createElement(Toggle, {
        "aria-label": messages.get("wizard.advanced.options"),
        className: "advanced-options-toggle",
        "data-analytics-track": "".concat(stepName, "-").concat(isAdvancedMode ? 'basic-mode' : 'advanced-mode'),
        id: "toggle-".concat(currentStepIndex)
        // hideLabel: use "[] sideLabel" instead of "label:" with colon on a line before
        ,
        hideLabel: true,
        toggled: isAdvancedMode,
        onToggle: function onToggle(state) {
          return _this8.handleWizardPageModeToggle(state, wizardStep);
        },
        onClick: function onClick(evt) {
          // Advanced tab was, for a single click, receiving 2 events and toggling twice
          // so that it would enable & disable, with overall no change. Preventing 2nd event:
          evt.preventDefault();
          evt.stopPropagation();
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "advanced-options-label-text",
        "aria-hidden": "true"
      }, messages.get("wizard.advanced.options"))), /*#__PURE__*/React.createElement(Toggletip, {
        className: "tooltip",
        align: "right"
      }, /*#__PURE__*/React.createElement(ToggletipButton, null, /*#__PURE__*/React.createElement(Information, null)), /*#__PURE__*/React.createElement(ToggletipContent, null, /*#__PURE__*/React.createElement(Markdown, {
        content: messages.get("wizard.advanced.options.tooltip")
      })))), showAuthLoadingState && /*#__PURE__*/React.createElement(SkeletonText, {
        paragraph: true,
        lineCount: 2,
        width: "45%"
      }), !errorState && !showAuthLoadingState && toolCapabilities.map(function (capability, i) {
        return _this8.renderWizardIntegrationDetails({
          capability: capability,
          currentStepIndex: currentStepIndex,
          invalidStepNames: invalidStepNames,
          index: i,
          wizardStep: wizardStep,
          wizard: wizard
        });
      }), !errorState && renderTektonRepos && this.renderRepoCapabilitiesList(tool, repoCapabilities, showAuthLoadingState), /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-footer"
      }, /*#__PURE__*/React.createElement(DeployButtons, {
        allowedRegion: this.props.allowedRegion,
        cancelHref: this.props.cancelHref,
        enableCreateButton: this.props.enableCreateButton,
        enableToolchainCreateButton: this.props.enableToolchainCreateButton,
        envId: this.props.envId,
        fsCloudDialogData: this.props.fsCloudDialogData,
        handleDeployClicked: this.props.handleDeployClicked,
        handleClick: this.handleWizardTabClick,
        isWizardInvalid: this.state.isWizardInvalid,
        locale: this.props.locale,
        nextIndex: currentStepIndex + 1,
        params: this.props.params,
        phase: this.props.phase,
        prevDisabled: false,
        prevIndex: currentStepIndex - 1,
        showCancel: false,
        showCreate: true,
        showNext: !isLastStep,
        showPrevious: true,
        stepName: stepName,
        wizardMode: this.props.wizardMode
      })))));
    }
  }, {
    key: "renderCreator",
    value: function renderCreator() {
      var _this9 = this;
      // Sorts tools so that git provider and pipeline are always first and second respectively
      var sortTools = function sortTools(a, b) {
        // TODO remove hardcoded list once this issue is finished https://github.ibm.com/org-ids/roadmap/issues/9823
        var validGitProviders = constants.gitServiceIds;
        if (validGitProviders.includes(a)) {
          if (validGitProviders.includes(b)) {
            return 0;
          }
          return -1;
        }
        if (validGitProviders.includes(b)) return 1;
        if (a === "pipeline") {
          if (b === "pipeline") {
            return 0;
          }
          return -1;
        }
        if (b === "pipeline") return 1;
        return 0;
      };
      var allTools = this.props.capabilities && this.props.capabilities.types({
        excludeWizardForms: true
      }) || [];
      allTools = this.hideMainPipelineRepos(allTools);
      var templateData = this.props.capabilities.getTopLevelData().services;

      // get the count of each tool.
      var toolCount = {};
      for (var data in templateData) {
        var serviceId = templateData[data].service_id;
        var kind = (templateData[data].parameters || {}).kind;

        // if kind exists exclude from count
        if (!kind) {
          if (toolCount[serviceId]) {
            toolCount[serviceId]++;
          } else {
            toolCount[serviceId] = 1;
          }
        }
      }
      var requiredTools = [];
      if (allTools && allTools.length) {
        // When reloading the template from a source-provider change, allTools is briefly empty
        // Only generate the list of required tools when allTools is NOT empty
        var requiredArray = (this.props.capabilities.getTemplate() || {}).required || [];
        var toolsMap = requiredArray.map(function (tool) {
          return templateData && templateData[tool] && templateData[tool].capabilityId;
        });
        requiredTools = _toConsumableArray(new Set(toolsMap));
      }
      var mainTools = allTools.filter(function (tool) {
        return requiredTools.find(function (reqTool) {
          return tool.includes(reqTool);
        });
      }).sort(sortTools);
      var otherTools = allTools.filter(function (tool) {
        return !mainTools.includes(tool);
      }).sort();
      mainTools.forEach(function (t) {
        _this9[t] = /*#__PURE__*/React.createRef();
      });
      otherTools.forEach(function (t) {
        _this9[t] = /*#__PURE__*/React.createRef();
      });
      var otherConfigRecommended = otherTools.map(function (tool) {
        var configRecommended = _this9.props.configRecommended[tool];
        if (configRecommended && configRecommended.invalidProps.length === 0 && tool === "pipeline") {
          configRecommended = undefined;
        }
        return !!(configRecommended ? configRecommended.invalidProps : configRecommended);
      }).some(function (rec) {
        return rec === true;
      });

      // Helper function that maps tools to tab number
      var mapToolsToTabNumber = function mapToolsToTabNumber(tool) {
        return mainTools.indexOf(tool) === -1 ? mainTools.length : mainTools.indexOf(tool);
      };

      // Switch tabs depending on if the user clicks create and if there are items that need configuration
      var selectedTab = this.props.createClicked && this.props.expandedType ? mapToolsToTabNumber(this.props.expandedType) : this.props.tabIndex;
      var toolAddedServiceLabel = null;
      if (this.props.context && this.props.context.enableSecretDtc) {
        var silentlyAddedTool = mainTools.find(function (tool) {
          var toolCapabilities = _this9.props.capabilities.getByType(tool);
          var addedIndex = toolCapabilities ? toolCapabilities.findIndex(function (item) {
            return !!item.silentlyAdded;
          }) : -1;
          return addedIndex !== -1;
        });
        if (silentlyAddedTool) {
          var tool = silentlyAddedTool;
          var toolCapabilities = this.props.capabilities.getByType(tool);
          var toolMetadata = this.props.capabilities.getMetadata(tool);
          var displayName = this.getDisplayName(tool, toolCapabilities, toolMetadata);
          toolAddedServiceLabel = displayName;
        }
      }
      var tabPanelArr = []; // each like <TabPanel/>
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.context && this.props.context.enableSecretDtc && !!toolAddedServiceLabel && /*#__PURE__*/React.createElement("div", {
        className: "tool-added"
      }, /*#__PURE__*/React.createElement(Notification, {
        kind: "success",
        subtitle: messages.get('infoBox.toolAdded', [toolAddedServiceLabel]),
        format: "markdown"
      })), /*#__PURE__*/React.createElement(Tabs, {
        className: "service-tabs",
        selectedIndex: selectedTab,
        onChange: function onChange(tabsState) {
          _this9.props.handleTabClick(tabsState.selectedIndex);
        }
      }, /*#__PURE__*/React.createElement(TabList, {
        "aria-label": messages.get("label.integrations")
      }, function () {
        // Note the TabList aria-label is the same as the preceeding <h2> element; might get repeated by screen readers
        var tabArr = mainTools.map(function (tool, index) {
          var id = "".concat(tool.replace(/[^a-z0-9_\-]/gi, ''), "-tab"); // derive a valid DOM id
          var idTabPanel = "".concat(tool.replace(/[^a-z0-9_\-]/gi, ''), "-tabpanel"); // derive a valid DOM id
          var toolMetadata = _this9.props.capabilities.getMetadata(tool);
          var toolCapabilities = _this9.props.capabilities.getByType(tool);
          var displayName = _this9.getDisplayName(tool, toolCapabilities, toolMetadata);
          var toolImageURL = _this9.getToolImageUrl(toolCapabilities, toolMetadata);

          // Determine if there are required fields
          var configRecommended = _this9.props.configRecommended[tool];
          if (configRecommended && configRecommended.invalidProps.length === 0 && tool === "pipeline") {
            configRecommended = undefined;
          }
          var isConfigRecommended = !!(configRecommended ? configRecommended.invalidProps : configRecommended);
          var isAdded = false;
          if (_this9.props.context && _this9.props.context.enableSecretDtc) {
            var addedIndex = toolCapabilities ? toolCapabilities.findIndex(function (item) {
              return !!item.silentlyAdded;
            }) : -1;
            isAdded = addedIndex !== -1;
          }
          var tab = /*#__PURE__*/React.createElement(Tab, {
            id: id,
            key: tool,
            "data-config-recommended": isConfigRecommended,
            "data-service-type": tool,
            "data-analytics-track": 'Tab ' + tool
          }, /*#__PURE__*/React.createElement("div", {
            className: "custom-tab-label",
            "data-recommended": isConfigRecommended
          }, /*#__PURE__*/React.createElement("div", {
            className: "tab-image-container"
          }, /*#__PURE__*/React.createElement("img", {
            className: "tab-image",
            src: toolImageURL,
            alt: ""
          })), /*#__PURE__*/React.createElement("div", {
            className: "display-labels"
          }, /*#__PURE__*/React.createElement("span", {
            className: "tab-display-name"
          }, displayName, toolCount[tool] > 1 ? ' (' + toolCount[tool] + ')' : ''), _this9.props.context && _this9.props.context.enableSecretDtc && isAdded && /*#__PURE__*/React.createElement("span", {
            className: "added-label"
          }, messages.get("label.added")), isConfigRecommended && /*#__PURE__*/React.createElement("span", {
            className: "required-label"
          }, messages.get("label.required")))));
          var tabPanel = /*#__PURE__*/React.createElement(TabPanel, {
            id: idTabPanel,
            key: tool
          }, /*#__PURE__*/React.createElement("div", {
            className: "tab-content-container"
          }, _this9.renderTabContents(tool)));
          tabPanelArr.push(tabPanel);
          return tab;
        }); // end mainTools.map

        if (otherTools.length > 0) {
          var tab = /*#__PURE__*/React.createElement(Tab, {
            id: "other-tab",
            key: "other",
            "data-config-recommended": otherConfigRecommended,
            "data-service-type": "other",
            "data-analytics-track": "Tab other"
          }, /*#__PURE__*/React.createElement("div", {
            className: "custom-tab-label"
          }, /*#__PURE__*/React.createElement("div", {
            className: "tab-image-container"
          }, /*#__PURE__*/React.createElement(OtherToolsSVG, {
            className: "tab-image"
          })), /*#__PURE__*/React.createElement("span", {
            className: "tab-display-name"
          }, messages.get("label.moreTools")), otherConfigRecommended && /*#__PURE__*/React.createElement("span", {
            className: "required-label"
          }, messages.get("label.required"))));
          var tabPanel = /*#__PURE__*/React.createElement(TabPanel, {
            id: "other-tabpanel",
            key: "other"
          }, /*#__PURE__*/React.createElement("div", {
            className: "tab-content-container more-tools-content"
          }, otherTools.map(function (tool) {
            return _this9.renderTabContents(tool);
          })));
          tabArr.push(tab);
          tabPanelArr.push(tabPanel);
        }
        return tabArr;
      }()), /*#__PURE__*/React.createElement(TabPanels, null, tabPanelArr)));
    }
  }, {
    key: "onWizardGitAcceptChange",
    value: function onWizardGitAcceptChange(value) {
      this.props.handleGitAcceptValid(value);
      var updatedCapabilities = this.props.capabilities.getWizard().handleGitAcceptChange(value);
      this.props.onScheduleWork("validate", updatedCapabilities && updatedCapabilities.map(function (c) {
        return {
          capability: c,
          changeSummary: null
        };
      }));
    }

    // Only used for v1 wizard rendering, welcome step only
  }, {
    key: "renderWelcomeSection",
    value: function renderWelcomeSection(isWelcomeInvalid) {
      var _this0 = this;
      var _this$props = this.props,
        capabilities = _this$props.capabilities,
        params = _this$props.params,
        phase = _this$props.phase;
      var wizard = capabilities.getWizard();
      var wizardDesc = wizard.getDescription();
      var gitLabelMarkdown = /*#__PURE__*/React.createElement(Markdown, {
        className: "checkboxLabel",
        content: wizard.getGitAcceptLabel()
      });
      return /*#__PURE__*/React.createElement("section", {
        "data-step": "welcome"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-header"
      }, /*#__PURE__*/React.createElement("h3", null, messages.get("label.welcome"))), /*#__PURE__*/React.createElement("div", {
        className: "form-div"
      }, wizardDesc && /*#__PURE__*/React.createElement(Markdown, {
        className: "long-desc-div",
        content: wizardDesc || ""
      }), this.props.renderToolchainName(), wizard.showGitAccept() === true && /*#__PURE__*/React.createElement(Checkbox, {
        labelText: gitLabelMarkdown,
        id: "git_accept_id",
        name: "git_accept_id",
        onChange: function onChange(evt, _ref5) {
          var checked = _ref5.checked,
            id = _ref5.id;
          return _this0.onWizardGitAcceptChange(checked);
        },
        checked: this.props.wizardGitAccept
      })), /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-footer"
      }, /*#__PURE__*/React.createElement(DeployButtons, {
        allowedRegion: this.props.allowedRegion,
        enableCreateButton: this.props.enableCreateButton,
        envId: this.props.envId,
        handleDeployClicked: this.props.handleDeployClicked,
        handleClick: this.handleWizardTabClick,
        locale: this.props.locale,
        nextIndex: 1,
        params: params,
        phase: phase,
        prevIndex: 0,
        showCancel: false,
        showCreate: false,
        showNext: true,
        showPrevious: false,
        stepName: "welcome",
        enableToolchainCreateButton: this.props.enableToolchainCreateButton,
        fsCloudDialogData: this.props.fsCloudDialogData,
        wizardMode: this.props.wizardMode
      })))));
    }

    // Only used for v2 wizard rendering, welcome & toolchain steps
  }, {
    key: "renderWelcomeDetails",
    value: function renderWelcomeDetails() {
      var _this$props2 = this.props,
        capabilities = _this$props2.capabilities,
        params = _this$props2.params,
        phase = _this$props2.phase;
      var availableCapabilities = capabilities ? capabilities.types({
        excludeWizardForms: true
      }).sort().map(function (type) {
        return capabilities.map[type][0];
      }) : [];
      var templateMetadata = capabilities === null || capabilities === void 0 ? void 0 : capabilities.getTemplate();
      var wizard = capabilities.getWizard();
      return /*#__PURE__*/React.createElement("section", {
        "data-step": "welcome"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-header"
      }, /*#__PURE__*/React.createElement("h3", null, messages.get("label.welcome"))), /*#__PURE__*/React.createElement("div", {
        className: "form-div"
      }, this.props.userInfo && /*#__PURE__*/React.createElement(WizardToolsPanel, {
        availableCapabilities: availableCapabilities,
        baseName: this.props.params.baseName,
        locale: this.props.locale,
        phase: phase,
        show: true,
        showTools: false,
        templateMetadata: templateMetadata,
        wizard: wizard
      })), /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-footer"
      }, /*#__PURE__*/React.createElement(DeployButtons, {
        allowedRegion: this.props.allowedRegion,
        enableCreateButton: this.props.enableCreateButton,
        envId: this.props.envId,
        handleDeployClicked: this.props.handleDeployClicked,
        handleClick: this.handleWizardTabClick,
        locale: this.props.locale,
        nextIndex: 1,
        params: params,
        phase: phase,
        prevIndex: 0,
        showCancel: false,
        showCreate: false,
        showNext: true,
        showPrevious: false,
        stepName: "welcome",
        enableToolchainCreateButton: this.props.enableToolchainCreateButton,
        fsCloudDialogData: this.props.fsCloudDialogData,
        wizardMode: this.props.wizardMode
      })))));
    }

    // Only used for v2 wizard rendering, welcome & toolchain steps
  }, {
    key: "renderToolchainStep",
    value: function renderToolchainStep(isWelcomeInvalid) {
      var _this1 = this;
      var _this$props3 = this.props,
        capabilities = _this$props3.capabilities,
        params = _this$props3.params,
        phase = _this$props3.phase;
      var wizard = capabilities.getWizard();
      var tcOptionsDesc = wizard.getToolchainDescription();
      var gitLabelMarkdown = /*#__PURE__*/React.createElement(Markdown, {
        className: "checkboxLabel",
        content: wizard.getGitAcceptLabel()
      });
      return /*#__PURE__*/React.createElement("section", {
        "data-step": "toolchain"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-header"
      }, /*#__PURE__*/React.createElement("h3", null, messages.get("wizard.label.toolchain.step"))), /*#__PURE__*/React.createElement("div", {
        className: "form-div"
      }, tcOptionsDesc && /*#__PURE__*/React.createElement(Markdown, {
        className: "long-desc-div",
        content: tcOptionsDesc || ""
      }), this.props.renderToolchainName(), wizard.showGitAccept() === true && /*#__PURE__*/React.createElement(Checkbox, {
        labelText: gitLabelMarkdown,
        id: "git_accept_id",
        name: "git_accept_id",
        onChange: function onChange(evt, _ref6) {
          var checked = _ref6.checked,
            id = _ref6.id;
          return _this1.onWizardGitAcceptChange(checked);
        },
        checked: this.props.wizardGitAccept
      })), /*#__PURE__*/React.createElement("div", {
        className: "tab-content-section-footer"
      }, /*#__PURE__*/React.createElement(DeployButtons, {
        allowedRegion: this.props.allowedRegion,
        enableCreateButton: this.props.enableCreateButton,
        envId: this.props.envId,
        handleDeployClicked: this.props.handleDeployClicked,
        handleClick: this.handleWizardTabClick,
        locale: this.props.locale,
        nextIndex: 2,
        params: params,
        phase: phase,
        prevIndex: 0,
        showCancel: false,
        showCreate: true,
        showNext: true,
        showPrevious: true,
        stepName: "toolchain",
        enableToolchainCreateButton: this.props.enableToolchainCreateButton,
        fsCloudDialogData: this.props.fsCloudDialogData,
        wizardMode: this.props.wizardMode
      })))));
    }
  }, {
    key: "handleWizardTabClick",
    value: function handleWizardTabClick(index) {
      if (index > this.props.tabIndex ||
      // Always set completedStep when continue button is clicked
      index < this.props.tabIndex && this.props.tabIndex === this.props.wizardCompletedStep // Dont set completed step when back button is clicked on a preview step
      ) {
        this.props.setWizardCompletedStep(index);
      }
      this.props.handleTabClick(index);
    }
  }, {
    key: "handleWizardPageModeToggle",
    value: function handleWizardPageModeToggle(state, wizardStep) {
      var mode = state ? "advanced" : "standard";
      wizardStep.setMode(mode);
      this.setState({
        wizardPageMode: _objectSpread(_objectSpread({}, this.state.wizardPageMode), {}, _defineProperty({}, wizardStep.getName(), mode))
      });
    }
  }, {
    key: "getWizardConfigRecommended",
    value: function getWizardConfigRecommended(wizardStep) {
      var _this10 = this;
      return !!wizardStep.getVisibleCapabilities().find(function (cap) {
        var configRecommended = _this10.props.configRecommended[cap.label];
        if (configRecommended && configRecommended.invalidProps.length === 0 && cap.capabilityId === "pipeline") {
          configRecommended = undefined;
        }
        var isConfigRecommended = !!(configRecommended ? configRecommended.invalidProps : configRecommended);
        return isConfigRecommended;
      });
    }
  }, {
    key: "renderWizardProgressSteps",
    value: function renderWizardProgressSteps(_ref7) {
      var _this11 = this;
      var isV2Wizard = _ref7.isV2Wizard,
        isWelcomeInvalid = _ref7.isWelcomeInvalid,
        welcomeOffset = _ref7.welcomeOffset,
        wizardSteps = _ref7.wizardSteps;
      var phase = this.props.phase;
      var progressSteps = [];
      progressSteps.push(/*#__PURE__*/React.createElement(ProgressStep, {
        description: messages.get("label.welcome"),
        key: "welcome",
        label: messages.get("label.welcome")
      }));
      if (isV2Wizard) {
        progressSteps.push(/*#__PURE__*/React.createElement(ProgressStep, {
          className: this.props.wizardCompletedStep > 0 ? "" : "wizard-incomplete-step",
          description: phase === Phase.READY && isWelcomeInvalid ? messages.get("label.required") : messages.get("wizard.label.toolchain.step"),
          invalid: phase === Phase.READY && isWelcomeInvalid,
          key: "toolchain",
          label: messages.get("wizard.label.toolchain.step")
        }));
      }
      if ((wizardSteps === null || wizardSteps === void 0 ? void 0 : wizardSteps.length) > 0) {
        wizardSteps.map(function (wizardStep, index) {
          var tool = wizardStep.getForm();
          var toolMetadata = _this11.props.capabilities.getMetadata(tool);
          var toolCapabilities = _this11.props.capabilities.getByType(tool);
          var displayName = _this11.getDisplayName(tool, toolCapabilities, toolMetadata, wizardStep);
          var stepName = wizardStep.getName();

          // Account for initial welcome step(s) offset
          var currentStepIndex = index + welcomeOffset;

          // Only show validation if all previous steps have been completed
          var isStepComplete = _this11.props.wizardCompletedStep >= currentStepIndex;
          // Determine if there are required fields
          var isConfigRecommended = phase === Phase.READY && isStepComplete && _this11.props.tabIndex >= currentStepIndex && _this11.getWizardConfigRecommended(wizardStep);

          // Determine indent level (e.g. an optional tool, or secrets integration)
          var indentLevel = wizardStep.indentLevel();
          var indentClass = indentLevel ? " wizard-step-indent indent-level-".concat(indentLevel) : "";
          var incompleteStepClass = _this11.props.wizardCompletedStep <= currentStepIndex ? " wizard-incomplete-step" : "";
          var stepClass = "wizard-step".concat(indentClass).concat(incompleteStepClass);
          progressSteps.push(/*#__PURE__*/React.createElement(ProgressStep, {
            className: stepClass,
            "data-analytics-track": "".concat(stepName, "-step"),
            description: isConfigRecommended ? messages.get("label.required") : displayName,
            invalid: isConfigRecommended,
            key: "".concat(tool, "-").concat(stepName),
            label: displayName,
            onClick: function onClick(index) {
              return _this11.props.handleTabClick(index);
            }
          }));
        });
      }
      return progressSteps;
    }
  }, {
    key: "renderWizard",
    value: function renderWizard() {
      var _this12 = this;
      var _this$props4 = this.props,
        capabilities = _this$props4.capabilities,
        isWizardWelcomeValid = _this$props4.isWizardWelcomeValid,
        phase = _this$props4.phase,
        validatorTracker = _this$props4.validatorTracker,
        wizardGitAccept = _this$props4.wizardGitAccept;

      // Wizard mode - get page ordering from wizard.yml
      var wizard = capabilities.getWizard();
      var wizardSteps = wizard.getSteps({
        visibleOnly: true
      });
      var isWelcomeInvalid = !isWizardWelcomeValid || wizard.showGitAccept() && !wizardGitAccept;
      var welcomeOffset = wizard.getWelcomeOffset();
      var isV2Wizard = wizard.isV2();
      var invalidStepNames = capabilities === null || capabilities === void 0 ? void 0 : capabilities.getInvalidWizardSteps();
      var tabPanelArr = []; // each is like: <TabPanel/>
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressIndicator, {
        currentIndex: this.props.tabIndex,
        spaceEqually: true,
        onChange: function onChange(index) {
          return _this12.props.handleTabClick(index);
        },
        vertical: true
      }, this.renderWizardProgressSteps({
        isV2Wizard: isV2Wizard,
        isWelcomeInvalid: isWelcomeInvalid,
        welcomeOffset: welcomeOffset,
        wizardSteps: wizardSteps
      })), /*#__PURE__*/React.createElement(Tabs, {
        selectedIndex: this.props.tabIndex,
        onChange: function onChange(tabsState) {
          _this12.props.handleTabClick(tabsState.selectedIndex);
        }
      }, /*#__PURE__*/React.createElement(TabList, {
        "aria-label": messages.get("label.integrations")
      }, !isV2Wizard && /*#__PURE__*/React.createElement(Tab, {
        "data-service-type": "welcome",
        "data-analytics-track": "Tab welcome",
        id: "tab-welcome",
        key: "welcome"
      }, messages.get("label.welcome"), function () {
        tabPanelArr.push(/*#__PURE__*/React.createElement(TabPanel, {
          id: "tabpanel-welcome",
          key: "welcome"
        }, /*#__PURE__*/React.createElement("div", {
          className: "tab-content-container"
        }, _this12.renderWelcomeSection(phase === Phase.READY && isWelcomeInvalid))));
      }()), isV2Wizard && /*#__PURE__*/React.createElement(Tab, {
        "data-service-type": "welcome",
        "data-analytics-track": "Tab welcome",
        id: "tab-welcome-split",
        key: "welcome"
      }, messages.get("label.welcome"), function () {
        tabPanelArr.push(/*#__PURE__*/React.createElement(TabPanel, {
          id: "tabpanel-welcome-split",
          key: "welcome"
        }, /*#__PURE__*/React.createElement("div", {
          className: "tab-content-container tab-content-wide"
        }, _this12.renderWelcomeDetails())));
      }()), isV2Wizard && /*#__PURE__*/React.createElement(Tab, {
        "data-service-type": "toolchain",
        "data-analytics-track": "Tab toolchain",
        id: "tab-toolchain",
        key: "toolchain"
      }, messages.get("wizard.label.toolchain.step"), function () {
        tabPanelArr.push(/*#__PURE__*/React.createElement(TabPanel, {
          id: "tabpanel-toolchain",
          key: "toolchain"
        }, /*#__PURE__*/React.createElement("div", {
          className: "tab-content-container"
        }, _this12.renderToolchainStep(phase === Phase.READY && isWelcomeInvalid))));
      }()), wizardSteps.length > 0 && wizardSteps.map(function (wizardStep, index) {
        var tool = wizardStep.getForm();
        var _wizardStep$getRender3 = wizardStep.getRenderData(),
          toolId = _wizardStep$getRender3.tool,
          toolMetadata = _wizardStep$getRender3.toolMetadata,
          toolCapabilities = _wizardStep$getRender3.toolCapabilities;
        var displayName = _this12.getDisplayName(toolId, toolCapabilities, toolMetadata, wizardStep);

        // Determine if there are required fields
        var isConfigRecommended = _this12.getWizardConfigRecommended(wizardStep);

        // Account for initial welcome step(s) offset
        var currentStepIndex = index + welcomeOffset;
        var isLastStep = currentStepIndex === wizardSteps.length - 1 + welcomeOffset;
        var tab = /*#__PURE__*/React.createElement(Tab, {
          "data-service-type": tool,
          "data-config-recommended": isConfigRecommended,
          "data-analytics-track": 'Tab ' + tool,
          id: "tab-".concat(wizardStep.getName()),
          key: "".concat(tool, "-").concat(wizardStep.getName())
        }, displayName);
        tabPanelArr.push(/*#__PURE__*/React.createElement(TabPanel, {
          id: "tabpanel-".concat(wizardStep.getName()),
          key: "".concat(tool, "-").concat(wizardStep.getName())
        }, /*#__PURE__*/React.createElement("div", {
          className: "tab-content-container"
        }, _this12.renderWizardTabContents({
          currentStepIndex: currentStepIndex,
          invalidStepNames: invalidStepNames,
          isLastStep: isLastStep,
          isWelcomeInvalid: isWelcomeInvalid,
          showImage: true,
          showTabContentHeader: true,
          wizard: wizard,
          wizardStep: wizardStep
        }))));
        return tab;
      })), /*#__PURE__*/React.createElement(TabPanels, null, tabPanelArr)));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.wizardMode) {
        return this.renderWizard();
      }
      return this.renderCreator();
    }
  }]);
}(React.Component);
export { ServiceTabs as default };
ServiceTabs.propTypes = _objectSpread(_objectSpread({}, ServiceTabs.propTypes), {}, {
  enableFSCloudDialog: PropTypes.bool.isRequired,
  wizardMode: PropTypes.bool.isRequired
});